"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const stileInterface_1 = require("./stileInterface");
const styled_components_1 = __importStar(require("styled-components"));
const Wrapper = styled_components_1.default.div `
    position: relative;
    background-color: #eee;
    overflow: hidden;
    margin: 0 auto;
    width: 100vw;
    height: ${(props) => props.height};
    top: 0;
    transform-origin: 50% 0;
    transform: scale(${(props) => String(props.scaling)});
`;
const GlobalStyle = (0, styled_components_1.createGlobalStyle) `
    body {
        // Some browsers add margin to the body element, causing unnecessary scrollbars to appear on our sims.
        margin: 0;
    }
`;
const SimController = (props) => {
    const [scaling, setScaling] = (0, react_1.useState)(1);
    const resize = (0, react_1.useCallback)(() => {
        // Convert our "56vw" string to a value we can use
        const heightFloat = parseFloat(props.height);
        try {
            // When the iFrame changes size we need to let the Stile simulation component know
            (0, stileInterface_1.sendStileEventCall)("changeWindowDimensions");
        }
        catch (e) {
            console.log(e);
            // We're probably not inside of Stile so resize to fit the screen
            // Let's figure out what the constraining resolution distance is
            // ie. do we have more width than height or vice versa
            const ratioWidth = window.innerWidth * heightFloat;
            const ratioHeight = window.innerHeight * 100;
            if (ratioWidth > ratioHeight) {
                // If we are height limited, then let's scale so we fit inside visible screen size
                setScaling(ratioHeight / ratioWidth);
            }
            else {
                setScaling(1);
            }
        }
    }, []);
    // We sometimes need to kick this on iOS chrome
    const resizeWithKick = (0, react_1.useCallback)(() => {
        resize();
        setTimeout(() => {
            resize();
        }, 200);
    }, []);
    (0, react_1.useEffect)(() => {
        resize();
        window.addEventListener("resize", resizeWithKick);
        return () => window.removeEventListener("resize", resizeWithKick);
    }, []);
    return props.isFullwindow ? (react_1.default.createElement(FullwindowWrapper, { id: "wrapper" },
        react_1.default.createElement(GlobalStyle, null),
        props.children)) : (react_1.default.createElement(Wrapper, { height: props.height, id: "wrapper", scaling: scaling },
        react_1.default.createElement(GlobalStyle, null),
        props.children));
};
const FullwindowWrapper = styled_components_1.default.div `
    width: 100%;
    height: 100%;
    position: fixed;
`;
exports.default = SimController;
